import { request } from './';

// TODO: yes there will be another kind of goal thats not personal

const fetchBadges = async () => {
    const result = await request('/badges/both/fetch', {});
    return result.data;
};
const addBadges = async (data) => {
    const result = await request('/badges/add', data);
    return result.data;
};
const editBadges = async (data) => {
    const result = await request('/badges/edit', data);
    return result.data;
};

const archiveBadges = async (data) => {
    const result = await request('/badges/archive', data);
    return result.data;
};

export default { fetchBadges, addBadges, editBadges, archiveBadges };
